import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAllVideos } from "@store/action/multimedia/VideoAction";
import { useTranslation } from "react-i18next";
import BreadCrumbs from "@components/breadcrumbs/index1";
import Filter from "./Filter";
import ReactPaginate from "react-paginate";
const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const Videos = () => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.VideoReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const per_page = 6;
  const count = Number(Math.ceil(store.total / per_page));

  useEffect(() => {
    dispatch(
      getAllVideos({
        page: currentPage,
        per_page: per_page,
        search: window.location.search,
      })
    );
    return () => {
      dispatch({
        type: "EMPTY_GET_ALL_VIDEOS",
      });
    };
  }, [dispatch, window.location.search, per_page]);
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getAllVideos({
        page: x.selected + 1,
        per_page: per_page,
        search: window.location.search,
      })
    );
  };

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Videos")} />
      <div className="treanding_songs_wrapper release_wrapper album_list_wrapper album_list_wrapper2 ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={setCurrentPage}
            />
            <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 album_list_wrapperOrder">
              <div className="tab-content">
                <div className="row">
                  {store?.total > 0 ? (
                    <>
                      {store?.data?.map((item, i) => {
                        return (
                          <div
                            className="col-xl-4 col-lg-5 col-md-6 col-sm-6 col-12 pd1"
                            key={i}
                          >
                            <div className="treanding_slider_main_box release_box_main_content ms_cover">
                              <video
                                style={{ borderRadius: "15px" }}
                                width="100%"
                                height="80%"
                                controls
                                src={item.file_path}
                              />
                              <div>
                                <p>
                                  <Link
                                    to={`/Gallery/Videos/topics/${item.id}`}
                                  >
                                    <span>{item.file_name}</span>
                                  </Link>
                                </p>
                                <p className="various_artist_text">
                                  <Link
                                    to={`/Gallery/Videos/topics/${item.id}`}
                                  >
                                    <span>{item.video_info?.length_text}</span>
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className="blog_pagination_section ">
                        <ReactPaginate
                          previousLabel={
                            <p className="prev">
                              <i className="flaticon-left-arrow" />
                            </p>
                          }
                          nextLabel={
                            <p className="next">
                              <i className="flaticon-right-arrow" />
                            </p>
                          }
                          pageRangeDisplayed={2}
                          marginPagesDisplayed={2}
                          pageCount={count || 1}
                          breakLabel="..."
                          activeClassName="third_pagger"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          onPageChange={(page) => handlePageChange(page)}
                          pageClassName={"page-item"}
                          containerClassName={
                            "pagination react-paginate justify-content-end p-1"
                          }
                        />
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center mt-2">
                      <p>{t("No Results")}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
